var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.6042 53.1875L43.6755 10.0208C42.9989 8.8491 42.0258 7.8761 40.854 7.19962C39.6823 6.52313 38.3531 6.16699 37 6.16699C35.647 6.16699 34.3178 6.52313 33.1461 7.19962C31.9743 7.8761 31.0012 8.8491 30.3246 10.0208L5.39588 53.1875C4.71908 54.3597 4.3629 55.6895 4.36316 57.0431C4.36342 58.3967 4.72012 59.7264 5.39737 60.8984C6.07463 62.0704 7.04856 63.0434 8.2212 63.7195C9.39385 64.3956 10.7239 64.751 12.0775 64.75H61.9226C63.2757 64.75 64.6049 64.3937 65.7767 63.7172C66.9485 63.0406 67.9216 62.0675 68.5981 60.8957C69.2746 59.7239 69.6308 58.3947 69.6308 57.0416C69.6308 55.6885 69.2746 54.3593 68.598 53.1875H68.6042Z",
    fill: "url(#paint0_linear_4683_14589)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37 46.2498C37.8078 46.2535 38.5878 45.9551 39.1868 45.4131C39.7858 44.8711 40.1606 44.1248 40.2375 43.3207L42.0567 25.129C42.1214 24.4852 42.0503 23.835 41.848 23.2205C41.6457 22.6059 41.3167 22.0406 40.8822 21.5611C40.4478 21.0816 39.9176 20.6986 39.3259 20.4369C38.7342 20.1751 38.0941 20.0404 37.4471 20.0415H36.5529C35.9065 20.0415 35.2673 20.177 34.6766 20.4392C34.0858 20.7014 33.5565 21.0846 33.1229 21.5639C32.6893 22.0433 32.361 22.6082 32.1591 23.2223C31.9573 23.8363 31.8864 24.4859 31.951 25.129L33.7702 43.3207C33.847 44.1235 34.2207 44.8687 34.8181 45.4105C35.4154 45.9523 36.1935 46.2516 37 46.2498Z",
    fill: "url(#paint1_linear_4683_14589)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37 58.5832C39.98 58.5832 42.3958 56.1674 42.3958 53.1873C42.3958 50.2073 39.98 47.7915 37 47.7915C34.0199 47.7915 31.6041 50.2073 31.6041 53.1873C31.6041 56.1674 34.0199 58.5832 37 58.5832Z",
    fill: "url(#paint2_linear_4683_14589)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4683_14589",
    x1: 18.7066,
    y1: 31.3513,
    x2: 64.7917,
    y2: 63.808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F59815"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4683_14589",
    x1: 31.3236,
    y1: 24.0313,
    x2: 42.4729,
    y2: 40.2605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E4154"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B2129"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4683_14589",
    x1: 33.5759,
    y1: 49.7633,
    x2: 40.2005,
    y2: 56.3878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E4154"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B2129"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning2);
export default __webpack_public_path__ + "static/media/warning2.1c0bb67a2dc895ab40fb95b9ae7f1d05.svg";
export { ForwardRef as ReactComponent };